// extracted by mini-css-extract-plugin
export default {"videoContainer":"Videos_videoContainer__Jsann"};